if (!customElements.get('gender-toggles')) {
  class GenderToggles extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      window.addEventListener('filters-rendered', () => {
        const mensFilter = document.querySelector('[data-action="apply-filter"][value="mens"]:checked');
        const womensFilter = document.querySelector('[data-action="apply-filter"][value="womens"]:checked');
        const radioAll = document.getElementById('quick-toggle-all');
        const radioMen = document.getElementById('quick-toggle-men');
        const radioWomen = document.getElementById('quick-toggle-women');
        const genderTogglesChecked = document.querySelectorAll('[data-label="Gender"] [data-action="apply-filter"]:checked');
                
        if (mensFilter && genderTogglesChecked.length <= 1) {
          if (radioMen.checked) return;
          radioMen.checked = true;
          radioMen.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (womensFilter && genderTogglesChecked.length <= 1) {
          if (radioWomen.checked) return;
          radioWomen.checked = true;
          radioWomen.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          radioAll.checked = true;
          radioAll.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    
      this.addEventListener('change', e => {
        const changedElement = e.target.closest('input');
        if (!changedElement) return;
        const genderTogglesChecked = document.querySelectorAll('[data-label="Gender"] [data-action="apply-filter"]:checked');
        
        switch(changedElement.value) {
          case 'men':
            const filterMen = document.querySelector('[data-action="apply-filter"][value="mens"]:not(:checked)');
            document.querySelectorAll('[data-label="Gender"] [data-action="apply-filter"]:not([value="mens"])').forEach(input => input.checked = false);
            if (!filterMen) {
              this.dispatchEvent(new Event('apply-filter', { bubbles: true }))
              return;
            };
            filterMen.checked = true;
            filterMen.dispatchEvent(new Event('apply-filter', { bubbles: true }));
          break;
          case 'women':
            const filterWomen = document.querySelector('[data-action="apply-filter"][value="womens"]:not(:checked)');
            document.querySelectorAll('[data-label="Gender"] [data-action="apply-filter"]:not([value="womens"])').forEach(input => input.checked = false);

            if (!filterWomen) {
              this.dispatchEvent(new Event('apply-filter', { bubbles: true }))
              return;
            };
            filterWomen.checked = true;
            filterWomen.dispatchEvent(new Event('apply-filter', { bubbles: true }));
            break;
          case 'all':
            if (genderTogglesChecked.length <= 1) {
              document.querySelector('[data-action="remove-filter"][data-filter-value="womens"]')?.click();
              document.querySelector('[data-action="remove-filter"][data-filter-value="mens"]')?.click();
            }
          break;
          default: break;
        }
        
      });
    }
  }

  customElements.define('gender-toggles', GenderToggles);
}
